import request from '../HantangTax/request'

const wechatAPI = 'wechat'

const url = {
  // 首页项目列表
  htIndex: `${wechatAPI}/new/htIndex`,
  // 任务详情
  projectDetails: `${wechatAPI}/new/projectDetails`,
  // 报名
  saveRegistPerson: `${wechatAPI}/new/saveRegistPerson`,
  // 我的任务列表
  taskList: `${wechatAPI}/new/taskList`,
  // 上传文件（现场照片/服务成果附件）
  uploadFile: `${wechatAPI}/new/files`,
  // 保存服务记录
  saveServiceRecord: `${wechatAPI}/new/saveServiceRecord`,
  // 服务记录列表
  serviceRecordList: `${wechatAPI}/new/serviceRecordList`,
  // 服务记录详情
  serviceRecordDetails: `${wechatAPI}/new/serviceRecordDetails`,
  // 根据经纬度获取当前服务地点
  getServiceLocation: `${wechatAPI}/new/getServiceLocation`
}

/**
 * 首页接口
 * 与 HantangTax 同域名（taxpay.htzl.vip），复用其 axios 实例，自动携带 TOKEN
 */
const requestHomeAPI = {
  /**
   * 首页项目列表（POST application/json）
   * @param {Object} params
   *   projectName   String 项目名称
   *   provinceCode  int    省
   *   cityCode      int    市
   *   districtCode  int    区县
   *   experience    int    经验（0不限 1:1-3年 2:3-5年 3:5-10年 4:10年以上）
   *   order         int    排序（1顺序 2倒序）
   * @returns Promise 响应体 res.data = {
   *   code, message,
   *   data: { pageSize, pageNum, total, rows: [{
   *     id, projectName, merName, provinceName, cityName, districtName,
   *     recruitCount, signCount, salaryRange, createTime, endTime
   *   }] }
   * }
   */
  htIndex: params => {
    return request.postJson(url.htIndex, params)
  },
  /**
   * 任务详情（POST application/json）
   * @param {Object} params
   *   projectId int 项目id（必填）
   * @returns Promise 响应体 res.data = {
   *   code, message,
   *   data: {
   *     projectId, projectName, merId, merNo, merName,
   *     provinceName, cityName, districtName,
   *     recruitCount, signCount, salaryRange,
   *     createTime, endTime, describe
   *   }
   * }
   */
  projectDetails: params => {
    return request.postJson(url.projectDetails, params)
  },
  /**
   * 报名（POST application/json）
   * @param {Object} params
   *   projectId   int    项目id（必填）
   *   name        String 姓名（必填）
   *   mobile      String 手机号（必填）
   *   merId       int    企业id
   *   merNo       String 企业编号
   *   merName     String 用工企业
   *   projectName String 项目名称
   * @returns Promise 响应体 res.data = { code, data, message }
   */
  saveRegistPerson: params => {
    return request.postJson(url.saveRegistPerson, params)
  },
  /**
   * 我的任务列表（POST application/json）
   * @param {Object} params
   *   taskStatus int 否 状态（0待审核 1待签约 2已签约 3未通过）
   *   pageNum    int 是 当前页码
   *   pageSize   int 是 显示条数
   * @returns Promise 响应体 res.data = {
   *   code, message,
   *   data: { pageSize, pageNum, total, rows: [{ projectName, merName, taskStatus }] }
   * }
   */
  taskList: params => {
    return request.postJson(url.taskList, params)
  },
  /**
   * 上传文件（POST multipart/form-data，参数名 file）
   * @param {File} file 图片/文档文件
   * @returns Promise 响应体 res.data = {
   *   code, message,
   *   data: { filePath, fileExt, fileName, fileSize }
   * }
   */
  uploadFile: file => {
    const formData = new FormData()
    formData.append('file', file)
    return request.upload(url.uploadFile, formData)
  },
  /**
   * 保存服务记录（POST application/json）
   * @param {Object} params
   *   merId          int     企业id（必填）
   *   projectId      int     任务id（必填）
   *   registPersonId int     报名任务id（必填）
   *   projectName    String  项目名称（必填）
   *   merName        String  公司名称（必填）
   *   serviceTime    String  服务时间（必填）
   *   longitude      String  经度（必填）
   *   latitude       String  纬度（必填）
   *   locaction      String  服务地址（必填）
   *   picList        Array   服务现场照片 [{ filePath }]（必填）
   *   fileList       Array   服务成果附件 [{ filePath }]（必填）
   *   content        String  服务说明（必填）
   * @returns Promise 响应体 res.data = { code, message, data }
   */
  saveServiceRecord: params => {
    return request.postJson(url.saveServiceRecord, params)
  },
  /**
   * 服务记录列表（POST application/json）
   * @param {Object} params
   *   projectName String 否 任务名称
   *   pageNum     int    是 当前页码
   *   pageSize    int    是 显示条数
   * @returns Promise 响应体 res.data = {
   *   code, message,
   *   data: { pageSize, pageNum, total, rows: [{ projectId, projectName, merName, recordCount }] }
   * }
   */
  serviceRecordList: params => {
    return request.postJson(url.serviceRecordList, params)
  },
  /**
   * 服务记录详情（POST application/json）
   * @param {Object} params
   *   projectId int 是 项目id
   *   pageNum   int 是 当前页码
   *   pageSize  int 是 显示条数
   * @returns Promise 响应体 res.data = {
   *   code, message,
   *   data: { pageSize, pageNum, total, rows: [{
   *     serviceRecordId, projectName, merName, serviceTime, locaction,
   *     picList: [{ filePath }], fileList: [{ filePath }], content
   *   }] }
   * }
   */
  serviceRecordDetails: params => {
    return request.postJson(url.serviceRecordDetails, params)
  },
  /**
   * 根据经纬度获取当前服务地点（POST application/json）
   * @param {Object} params
   *   longitude String 经度（必填）
   *   latitude  Number 纬度（必填）
   * @returns Promise 响应体 res.data = { code, message, data: String 服务地点 }
   */
  getServiceLocation: params => {
    return request.postJson(url.getServiceLocation, params)
  }
}

export default requestHomeAPI
